import { Routes, Route } from 'react-router-dom';

import App from './App';
import LoginPage from './login/LoginPage';

import UsersPage from './pages/UsersPage'
import UserPage from './pages/UserPage'
import PageNotFound from './pages/PageNotFound';
import ProductsPage from './pages/ProductsPage';
import ProductPage from './pages/ProductPage';
import MaintenancesPage from './pages/MaintenancesPage';
import MaintenancePage from './pages/MaintenancePage';
import ClientsPage from './pages/ClientsPage';
import ClientPage from './pages/ClientPage';
import DashboardPage from './pages/DashboardPage';
import StatsPage from './pages/StatsPage';
import ShippingsPage from './pages/ShippingsPage';
import ShippingPage from './pages/ShippingPage';
import PresencePage from './pages/PresencePage';
import PresenceReportsPage from './pages/PresenceReportsPage';
import PresenceReportPage from './pages/PresenceReportPage';
import SupplierPage from './pages/SupplierPage';
import SuppliersPage from './pages/SuppliersPage';


const Navigation = () => {
  return (
    <Routes>
      <Route path="*" element={<PageNotFound />} />
      <Route path="/login" element={<LoginPage />} />


      <Route path="/" element={<App />}>

        <Route index element={<DashboardPage />} />

        <Route path="dashboard" element={<DashboardPage />} />


        <Route path="settings">
          <Route path="stats" element={<StatsPage />} />

          <Route path="products" element={<ProductsPage />} />
          <Route path="product/:id" element={<ProductPage />} />
          <Route path="product" element={<ProductPage />} />

          <Route path="maintenances" element={<MaintenancesPage />} />
          <Route path="maintenance/:id" element={<MaintenancePage />} />
          <Route path="maintenance" element={<MaintenancePage />} />

          <Route path="clients" element={<ClientsPage />} />
          <Route path="client/:id" element={<ClientPage />} />
          <Route path="client" element={<ClientPage />} />

          <Route path="shippings" element={<ShippingsPage />} />
          <Route path="shipping/:id" element={<ShippingPage />} />
          <Route path="shipping" element={<ShippingPage />} />

          <Route path="suppliers" element={<SuppliersPage />} />
          <Route path="supplier/:id" element={<SupplierPage />} />
          <Route path="supplier" element={<SupplierPage />} />

          <Route path="users" element={<UsersPage />} />
          <Route path="user/:id" element={<UserPage />} />
          <Route path="user" element={<UserPage />} />

          <Route path="presence" element={<PresencePage />} />
          <Route path="presenceReports" element={<PresenceReportsPage />} />
          <Route path="presenceReport/:id" element={<PresenceReportPage />} />
          <Route path="presenceReport" element={<PresenceReportPage />} />
        </Route>

      </Route>
    </Routes>
  );
};

export default Navigation;
